import { render } from "./DeleteWaypointsModal.vue?vue&type=template&id=240da8d8"
import script from "./DeleteWaypointsModal.vue?vue&type=script&lang=js"
export * from "./DeleteWaypointsModal.vue?vue&type=script&lang=js"
script.render = render
/* hot reload */
if (module.hot) {
  script.__hmrId = "240da8d8"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('240da8d8', script)) {
    api.reload('240da8d8', script)
  }
  
  module.hot.accept("./DeleteWaypointsModal.vue?vue&type=template&id=240da8d8", () => {
    api.rerender('240da8d8', render)
  })

}

script.__file = "resources/js/Pages/Tour/Partials/CoordinateData/DeleteWaypointsModal.vue"

export default script